import React, { useEffect, useState } from 'react'
import { selectGlobalDataState } from '../features/global/globalDataSlice'
import { Grid } from '@mui/material';
import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom'
import Utilities from '../components/main/payments/paymentsMain/allUtilities/Utilities'
import Utility from '../components/main/payments/utilities/Utility'
import colors from '../components/colors'
import RouteBasedButtonGroup from '../components/general/RouteBasedButtonGroup'
import Oshee from '../components/main/payments/utilities/oshee/Oshee'
import Gjobat from '../components/main/payments/utilities/gjobat/Gjobat'
import Digicom from '../components/main/payments/utilities/internet/digicom/Digicom'
import * as config from '../components/config'
import { selectPaymentsState } from '../features/payments/paymentsSlice';
import { selectUserInfo } from '../features/userInfo/userInfoSlice';
import { useSelector, useDispatch } from 'react-redux';
import UtilityTaksat from '../components/main/payments/utilities/taksat/UtilityTaksat';
import UtilityDigitalb from '../components/main/payments/utilities/digitalb/UtilityDigitalb';
import Qezhef from '../components/main/payments/utilities/qezhef/Qezhef';
import Abissnet from '../components/main/payments/utilities/internet/abissnet/Abissnet';
import Albtelecom from '../components/main/payments/utilities/internet/albtelecom/Albtelecom';
import Digitalb from '../components/main/payments/utilities/digitalb/Digitalb';
import UtilityAlbtelecomMobile from '../components/main/payments/utilities/albtelecomMobile/UtilityAlbtelecomMobile';
import UtilityOne from '../components/main/payments/utilities/oneMobile/UtilityOne';
import { clearUtilitySliceState, selectUtilityState } from '../features/utilities/utilitySlice'
import UtilityVodafoneInvoices from '../components/main/payments/utilities/vodafone/vodafoneInvoices/UtilityVodafoneInvoices';
import UtilityVodafoneTopup from '../components/main/payments/utilities/vodafone/vodafoneTopup/UtilityVodafoneTopup';
import { sendGeneralRequest } from '../features/generalRequest'
import { resetUtilityInfo } from '../features/utilities/utilitySlice';
import InternetUtilitiesView from '../components/main/payments/utilities/internet/InternetUtilitiesView'
import Ujesjelles from '../components/main/payments/utilities/ujesjellesi/Ujesjelles'
import { useLocation } from "react-router-dom";
import MyContracts from '../components/main/payments/utilities/myContracts/MyContracts';
import Favorites from '../components/main/favorites/Favorites';
import TransactionHistory from '../components/main/dashboard/latesetTransactions/transactionHistory/TransactionHistory';
import Taksat from '../components/main/payments/utilities/taksat/Taksat';
import One from '../components/main/payments/utilities/oneMobile/One';
import AlbtelecomMobile from '../components/main/payments/utilities/albtelecomMobile/AlbtelecomMobile';
import VodafoneTopup from '../components/main/payments/utilities/vodafone/vodafoneTopup/VodafoneTopup';
import VodafoneInvoices from '../components/main/payments/utilities/vodafone/vodafoneInvoices/VodafoneInvoices';
import { texts } from '../components/general/texts';
import TaksatOffline from '../components/main/payments/utilities/taksatVendore/TaksatOffline';
import DigitalbOTT from '../components/main/payments/utilities/digitalb/DigitalbOTT';
import Siguracione from '../components/main/payments/utilities/siguracionet/Siguracione';
import axios from 'axios';
import geolocation from 'geolocation';
import { selectDigitalbState } from '../features/digitalb/digitalbSlice';
import UtilityOneInvoices from '../components/main/payments/utilities/oneMobile/oneInvoices/UtilityOneInvoices';
import OneInvoices from '../components/main/payments/utilities/oneMobile/oneInvoices/OneInvoices';
import CannotUseService from '../components/general/CannotUseService';
import Noa from '../components/main/payments/utilities/mikrokredi/NOA/Noa';
import Kredo from '../components/main/payments/utilities/mikrokredi/Kredo/Kredo';
import FshatiSos from '../components/main/payments/utilities/donacione/FshatiSos';
import Tpl from '../components/main/payments/utilities/siguracioneMotorike/Tpl';
import Esim99 from '../components/main/payments/utilities/esim/99esim/99esim';
import Firstcom from '../components/main/payments/utilities/internet/firstcom/Firstcom';

const Payments = () => {
  const tabs = [{ display: texts["title-utilities"], value: '' }, { display: texts["title-favorite"], value: 'favorites' }, { display: texts["title-history"], value: 'history' }];
  const globalDataSliceState = useSelector(selectGlobalDataState)
  const paymentsSliceState = useSelector(selectPaymentsState)
  const digitalbSliceState = useSelector(selectDigitalbState)
  const userInfo = useSelector(selectUserInfo)
  const utilitySliceState = useSelector(selectUtilityState)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const location = useLocation()
  const [latitude, setLatitude] = useState('');
  const [longitude, setLongitude] = useState('');
  const digitalbSubUtilities = [{ image: "https://www.easypay.al/MobileLogos/servicesCategory/digitalb.png", publicName: "Digitalb Tokesor/Satelitor", serviceName: "DIGITALB", status: 0 }, { image: "https://www.easypay.al/MobileLogos/servicesCategory/digitalb.png", publicName: "Digitalb OTT", serviceName: "DIGITALBOTT", status: 0 }
  ]
  const currentURL = window.location.href;
  const segments = currentURL.split('/');
  const utilityName = segments[segments.length - 1];
  const getValueFromButtonGroup = (value) => {
    navigate(value)
  }

  useEffect(() => {
    console.log(paymentsSliceState.specificUtilityInfo)
    dispatch(clearUtilitySliceState());
    paymentsSliceState.utilities.length === 0 &&
      dispatch(
        sendGeneralRequest({
          request: { token: globalDataSliceState.token },
          baseUrlKey: 'services',
          endpoint: 'GetServices',
        })
      );
  }, [paymentsSliceState.utilities, location]);

  useEffect(() => {
    if (utilityName === 'DIGITALB') {
      geolocation.getCurrentPosition((err, position) => {
        if (err) {
          console.error('Geolocation error:', err);
        } else {
          setLatitude(position.coords.latitude);
          setLongitude(position.coords.longitude);
        }
      });
    }
  }, [utilityName]);

  useEffect(() => {
    if (latitude !== '' && longitude !== '') {
      dispatch(
        sendGeneralRequest({
          request: {
            token: globalDataSliceState.token,
            latitude: latitude,
            longitude: longitude,
          },
          baseUrlKey: 'services',
          endpoint: 'DGA/GetProductsOTT',
        })
      );
    }
  }, [latitude, longitude]);


  const selectedButtonStyle =
  {
    backgroundColor: colors.lightOrange,
    color: colors.orange,
    fontFamily: 'GerberaBold',
    borderRadius: '10px',
    textTransform: 'none',
    minWidth: '27vh',
    minHeight: '5vh',
    border: '1.5px solid' + colors.orange,
    '&:hover': {
      backgroundColor: colors.lightOrange
    }
  }
  const defaultButtonStyle =
  {
    backgroundColor: colors.mediumGray,
    color: colors.darkBlue,
    fontFamily: 'GerberaLight',
    textTransform: 'none',
    borderRadius: '10px',
    minWidth: '27vh',
    minHeight: '5vh',
    '&:hover': {
      backgroundColor: colors.lightOrange
    }
  }

  return (
    <Grid container flexDirection={'column'} >
      <Grid container item md={12} columnSpacing={20} rowSpacing={5} justifyContent='center' pt={2}>
        {/* <ButtonGroup state={tabs} sendValue={getValueFromButtonGroup} selectedButtonStyle={selectedButtonStyle} defaultButtonStyle={defaultButtonStyle}/>*/}
        <RouteBasedButtonGroup routeEndpointPosition={0} state={tabs} sendValue={getValueFromButtonGroup} selectedButtonStyle={selectedButtonStyle} defaultButtonStyle={defaultButtonStyle} />
      </Grid>
      <Grid container item md={12}>
        <Routes>
          <Route index element={<Utilities utilities={paymentsSliceState.utilities} />} />
          <Route path={"oshee"} element={<Utility utility={Oshee} utilityInfo={paymentsSliceState.specificUtilityInfo.filter(utility => utility.Name === 'OSHEE')[0]} />} />
          <Route path={"gjobat"} element={<Utility utility={Gjobat} utilityInfo={paymentsSliceState.specificUtilityInfo.filter(utility => utility.Name === 'GJOBAT')[0]} />} />
          <Route path={"qezhef"} element={<Utility utility={Qezhef} utilityInfo={paymentsSliceState.specificUtilityInfo.filter(utility => utility.Name === 'QEZHEF')[0]} />} />
          <Route path={"dpttv"} element={<UtilityTaksat utility={Taksat} utilityInfo={paymentsSliceState.specificUtilityInfo.filter(utility => utility.Name === 'DPTTV')[0]} />} />
          <Route path={"Siguracione"} element={<Utility utility={Siguracione} utilityInfo={paymentsSliceState.specificUtilityInfo.filter(utility => utility.name === 'Siguracione')[0]} />} />
          <Route path={"Taksa%20Vendore"} element={<Utilities utilities={paymentsSliceState.taksatVendoreSubUtilities} />} />
          <Route path={"Taksa%20Vendore/dpttv"} element={<UtilityTaksat utility={Taksat} utilityInfo={paymentsSliceState.specificUtilityInfo.filter(utility => utility.Name === 'DPTTV')[0]} />} />
          <Route path={"Taksa%20Vendore/TAKSAT_DURRES"} element={<Utility utility={TaksatOffline} utilityInfo={paymentsSliceState.taksatVendoreSpecificUtilityInfo.filter(utility => utility.Name === 'TAKSAT_DURRES')[0]} />} />
          <Route path={"Taksa%20Vendore/TAKSAT_SHKODER"} element={<Utility utility={TaksatOffline} utilityInfo={paymentsSliceState.taksatVendoreSpecificUtilityInfo.filter(utility => utility.Name === 'TAKSAT_SHKODER')[0]} />} />
          <Route path={"internet"} element={<Utilities utilities={paymentsSliceState.internetSubUtilities} />} />
          <Route path={"internet/digicom"} element={<Utility utility={Digicom} utilityInfo={paymentsSliceState.internetSpecificUtilityInfo.filter(utility => utility.Name === 'DIGICOM')[0]} />} />
          <Route path={"internet/abissnet"} element={<Utility utility={Abissnet} utilityInfo={paymentsSliceState.internetSpecificUtilityInfo.filter(utility => utility.Name === 'ABISSNET')[0]} />} />
          <Route path={"internet/albtelecom"} element={<Utility utility={Albtelecom} utilityInfo={paymentsSliceState.internetSpecificUtilityInfo.filter(utility => utility.Name === 'ALBTELECOM')[0]} />} />
          <Route path={"internet/FirstCom"} element={<Utility utility={Firstcom} utilityInfo={paymentsSliceState.internetSpecificUtilityInfo.filter(utility => utility.Name === 'FirstCom')[0]} />} />
          <Route path={"ujesjelles"} element={<Utility utility={Ujesjelles} utilityInfo={paymentsSliceState.ujesjellesSubUtilities.filter(utility => utility.serviceName === utilitySliceState.utilityName)[0]} />} />
          {/* <Route path={"ujesjelles"} element={<Utilities utilities={paymentsSliceState.ujesjellesSubUtilities}/>}/>
                    <Route path={"ujesjelles/*"} element={<Utility utility={Ujesjelles} utilityInfo={paymentsSliceState.ujesjellesSpecificUtilityInfo}/>}/>     */}
          <Route path={"digitalb"} element={<Utilities utilities={digitalbSubUtilities} />} />
          <Route path={"digitalb/digitalb"} element={<UtilityDigitalb utility={Digitalb} utilityInfo={paymentsSliceState.specificUtilityInfo.filter(utility => utility.Name === 'DIGITALB')[0]} />} />
          <Route path={"digitalb/digitalbott"} element={<UtilityDigitalb utility={DigitalbOTT} utilityInfo={paymentsSliceState.specificUtilityInfo.filter(utility => utility.Name === 'DIGITALB')[0]} />} />
          {/* <Route path={"TELEKOM%20ALBANIA"} element={<UtilityOne utility={One} utilityInfo={paymentsSliceState.specificUtilityInfo.filter(utility => utility.Name === 'TELEKOM ALBANIA')[0]} />} />
          <Route path={"utilities/TELEKOM%20ALBANIA"} element={<UtilityOne utility={One} utilityInfo={paymentsSliceState.specificUtilityInfo.filter(utility => utility.Name === 'TELEKOM ALBANIA')[0]} />} /> */}
          <Route path={"TELEKOM%20ALBANIA"} element={<Utilities utilities={paymentsSliceState.oneSubUtilities} />} />
          <Route path={"/TELEKOM%20ALBANIA/Pagese%20ONE"} element={<UtilityOneInvoices utility={OneInvoices} utilityInfo={paymentsSliceState.specificUtilityInfo.filter(utility => utility.Name === 'TELEKOM ALBANIA')[0]} />} />
          <Route path={"/TELEKOM%20ALBANIA/ONE%20TOPUP"} element={<UtilityOne utility={One} utilityInfo={paymentsSliceState.specificUtilityInfo.filter(utility => utility.Name === 'TELEKOM ALBANIA')[0]} />} />
          <Route path={"vodafone"} element={<Utilities utilities={paymentsSliceState.vodafoneSubUtilities} />} />
          <Route path={"vodafone/Pagese%20VODAFONE"} element={<UtilityVodafoneInvoices utility={VodafoneInvoices} utilityInfo={paymentsSliceState.specificUtilityInfo.filter(utility => utility.Name === 'VODAFONE')[0]} />} />
          <Route path={"vodafone/VODAFONE%20TOPUP"} element={<UtilityVodafoneTopup utility={VodafoneTopup} utilityInfo={paymentsSliceState.specificUtilityInfo.filter(utility => utility.Name === 'VODAFONE')[0]} />} />
          <Route path={"MIKROKREDI"} element={<Utilities utilities={paymentsSliceState.microloanSubUtilities} />} />
          <Route path={"MIKROKREDI/KREDO"} element={<Utility utility={Kredo} utilityInfo={paymentsSliceState?.microloanSpecificUtilityInfo?.filter(utility => utility.Name === 'KREDO')[0]} />} />
          <Route path={"MIKROKREDI/NOA"} element={<Utility utility={Noa} utilityInfo={paymentsSliceState?.microloanSpecificUtilityInfo?.filter(utility => utility.Name === 'NOA')[0]} />} />
          <Route path={"eagle"} element={<UtilityAlbtelecomMobile utility={AlbtelecomMobile} utilityInfo={paymentsSliceState.specificUtilityInfo.filter(utility => utility.Name === 'EAGLE')[0]} />} />
          <Route path={"favorites"} element={<Favorites utilityName={''} />} />
          <Route path={"history"} element={<TransactionHistory transactionHistory={userInfo.transactionHistory} />} />
          <Route path={"TiranaMarathon"} element={<CannotUseService />} />
          <Route path={"DONACIONE"} element={<Utilities utilities={paymentsSliceState.donationSubUtilities} />} />
          <Route path={"DONACIONE/Fshati_SOS"} element={<FshatiSos/>} />
          <Route path={"SIGURIIME_MOTORRIKE"} element={<Utilities utilities={paymentsSliceState.sigurimeMotorrikeSubUtilities} />} />
          <Route path={"SIGURIIME_MOTORRIKE/SIGAL_TPL"} element={<Utility utility={Tpl} utilityInfo={paymentsSliceState.sigurimeMotorrikeSpecificUtilityInfo && paymentsSliceState.sigurimeMotorrikeSpecificUtilityInfo.filter(utility => utility.Name === 'SIGAL_TPL')[0]} />} />
          <Route path={"ESIM"} element={<Utilities utilities={paymentsSliceState.esimSubUtilities} />} />
          <Route path={"ESIM/ESIM_99"} element={<Esim99 utilityInfo={paymentsSliceState?.esimSpecificUtilityInfo?.filter(utility => utility.Name === 'ESIM_99')[0]} />} />
        </Routes> 
      </Grid>
    </Grid>
  )
}

export default Payments

